import React from 'react';
import { StyledEngineProvider, ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { useMuiBrandTheme } from './useMuiBrandTheme';

/**
 * Global MUI brand theme provider — same tokens as /mui-preview lab.
 * Wraps the whole app so /home (and all routes) get Quicksand,
 * pill Tabs, 16px Paper, brand primary/secondary reactivity.
 * /mui-preview keeps its own nested provider (harmless override).
 */
export const MuiBrandProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { theme } = useMuiBrandTheme();

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          {children}
        </LocalizationProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default MuiBrandProvider;
